var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"to-top-button",class:{ active: _vm.showButton },attrs:{"title":"To Top"},on:{"click":_vm.scrollToTop}},[_c('IconArrow',{staticClass:"to-top-button__white",attrs:{"fill":"#fff"}}),_vm._v(" "),_c('IconArrow',{staticClass:"to-top-button__gray",attrs:{"fill":"#b2b2b3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }